import {ChangeDetectorRef, Directive, ElementRef, HostListener} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";

@Directive()
export abstract class FUIAbstractSearchInput extends FUIAbstractInput {
    constructor(public elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }

    /**
     * If a user presses space while in the search input, prevent it from propagating to a select
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public keypress(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if (keyboardEvent.code === "Space" || keyboardEvent.key === " ") {
                keyboardEvent.stopPropagation();
            }
        }
    }
}
